var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import 'monaco-editor/esm/vs/editor/browser/controller/coreCommands.js';
import 'monaco-editor/esm/vs/editor/browser/widget/codeEditorWidget.js';
// import 'monaco-editor/esm/vs/editor/browser/widget/diffEditorWidget.js';
// import 'monaco-editor/esm/vs/editor/browser/widget/diffNavigator.js';
// import 'monaco-editor/esm/vs/editor/contrib/anchorSelect/anchorSelect.js';
import 'monaco-editor/esm/vs/editor/contrib/bracketMatching/browser/bracketMatching.js';
// import 'monaco-editor/esm/vs/editor/contrib/caretOperations/caretOperations.js';
// import 'monaco-editor/esm/vs/editor/contrib/caretOperations/transpose.js';
// import 'monaco-editor/esm/vs/editor/contrib/clipboard/clipboard.js';
// import 'monaco-editor/esm/vs/editor/contrib/codeAction/codeActionContributions.js';
// import 'monaco-editor/esm/vs/editor/contrib/codelens/codelensController.js';
// import 'monaco-editor/esm/vs/editor/contrib/colorPicker/colorContributions.js';
import 'monaco-editor/esm/vs/editor/contrib/comment/browser/comment.js';
// import 'monaco-editor/esm/vs/editor/contrib/contextmenu/contextmenu.js';
import 'monaco-editor/esm/vs/editor/contrib/cursorUndo/browser/cursorUndo.js';
// import 'monaco-editor/esm/vs/editor/contrib/dnd/dnd.js';
// import 'monaco-editor/esm/vs/editor/contrib/documentSymbols/documentSymbols.js';
import 'monaco-editor/esm/vs/editor/contrib/find/browser/findController.js';
// import 'monaco-editor/esm/vs/editor/contrib/folding/folding.js';
// import 'monaco-editor/esm/vs/editor/contrib/fontZoom/fontZoom.js';
// import 'monaco-editor/esm/vs/editor/contrib/format/formatActions.js';
// import 'monaco-editor/esm/vs/editor/contrib/gotoError/gotoError.js';
// import 'monaco-editor/esm/vs/editor/contrib/gotoSymbol/goToCommands.js';
// import 'monaco-editor/esm/vs/editor/contrib/gotoSymbol/link/goToDefinitionAtPosition.js';
// import 'monaco-editor/esm/vs/editor/contrib/hover/hover.js';
// import 'monaco-editor/esm/vs/editor/contrib/inPlaceReplace/inPlaceReplace.js';
import 'monaco-editor/esm/vs/editor/contrib/indentation/browser/indentation.js';
// import 'monaco-editor/esm/vs/editor/contrib/inlineHints/inlineHintsController.js';
// import 'monaco-editor/esm/vs/editor/contrib/linesOperations/linesOperations.js';
// import 'monaco-editor/esm/vs/editor/contrib/linkedEditing/linkedEditing.js';
// import 'monaco-editor/esm/vs/editor/contrib/links/links.js';
// import 'monaco-editor/esm/vs/editor/contrib/multicursor/multicursor.js';
// import 'monaco-editor/esm/vs/editor/contrib/parameterHints/parameterHints.js';
import 'monaco-editor/esm/vs/editor/contrib/rename/browser/rename.js';
// import 'monaco-editor/esm/vs/editor/contrib/smartSelect/smartSelect.js';
// import 'monaco-editor/esm/vs/editor/contrib/snippet/snippetController2.js';
import 'monaco-editor/esm/vs/editor/contrib/suggest/browser/suggestController.js';
// import 'monaco-editor/esm/vs/editor/contrib/toggleTabFocusMode/toggleTabFocusMode.js';
// import 'monaco-editor/esm/vs/editor/contrib/unusualLineTerminators/unusualLineTerminators.js';
// import 'monaco-editor/esm/vs/editor/contrib/viewportSemanticTokens/viewportSemanticTokens.js';
// import 'monaco-editor/esm/vs/editor/contrib/wordHighlighter/wordHighlighter.js';
// import 'monaco-editor/esm/vs/editor/contrib/wordOperations/wordOperations.js';
// import 'monaco-editor/esm/vs/editor/contrib/wordPartOperations/wordPartOperations.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/accessibilityHelp/accessibilityHelp.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/inspectTokens/inspectTokens.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneCommandsQuickAccess.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneHelpQuickAccess.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/referenceSearch/standaloneReferenceSearch.js';
// import 'monaco-editor/esm/vs/editor/standalone/browser/toggleHighContrast/toggleHighContrast.js';
// END_FEATURES
// import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
// import * as monaco from 'monaco-editor';
import './styles/syntax/elm.contribution';
// @ts-ignore
self.MonacoEnvironment = {
    getWorkerUrl: function (moduleId, label) {
        // if (label === 'json') {
        // 	return './json.worker.bundle.js';
        // }
        // if (label === 'css' || label === 'scss' || label === 'less') {
        // 	return './css.worker.bundle.js';
        // }
        // if (label === 'html' || label === 'handlebars' || label === 'razor') {
        // 	return './html.worker.bundle.js';
        // }
        // if (label === 'typescript' || label === 'javascript') {
        // 	return './ts.worker.bundle.js';
        // }
        return './editor.worker.js';
    }
};
var theme = 'vs-dark'; // 'vs-dark'
export var editors = new Map(); //: Pair<monaco.editor.IStandaloneCodeEditor,monaco.editor.ITextModel>[]= [];
var first = false;
// declare let self: any;
// let MonacoEnvironment;
export function setupProgramEditor(node, editorOptions, defaultSource) {
    if (editorOptions === void 0) { editorOptions = {}; }
    if (defaultSource === void 0) { defaultSource = null; }
    var options = __assign({ value: [(defaultSource != null ? defaultSource :
                '\n' /*`module PlayLand exposing (..)
            
            -- Welcome to PlayLand!
            
            nums : number -> List number
            nums n =
              if n == 0
                then []
                else n :: nums (n - 1)
            
            fib : number -> number
            fib n =
              if n < 2
                then 1
                else fib (n - 1) + fib (n - 2)
            
            fibs : number -> List number
            fibs n = List.map fib (nums n)
            
            `*/)
        ].join('\n'), language: 'elm', theme: theme, automaticLayout: true, wordWrap: 'on', wrappingIndent: 'indent' }, editorOptions);
    // first = true;
    var editor = monaco.editor.create(node, options);
    editors.set('program-editor', editor);
    return node;
}
export function setupReplOutput(node) {
    var options = {
        language: 'elm',
        theme: theme,
        automaticLayout: true,
        readOnly: true,
        wordWrap: 'on',
        wrappingIndent: 'indent'
    };
    var editor = monaco.editor.create(node, options);
    editors.set('repl-output', editor);
    setTimeout(function () {
        var container = document.getElementById('eval-container');
        container.classList.add('eval-output-window');
        // const backgrounds = [...container.querySelectorAll('.monaco-editor-background'),...container.querySelectorAll('.monaco-editor'),...container.querySelectorAll('.margin')]
        // for (const bg of backgrounds) {
        //     bg.style.backgroundColor = '#1a2e34';
        //     bg.style.cssText += 'background-color: #1a2e34 !important;';
        // }
    }, 0);
    return node;
}
export function setupReplInput(node) {
    var options = {
        language: 'elm',
        theme: theme,
        automaticLayout: true,
        wordWrap: 'on',
        wrappingIndent: 'indent'
    };
    var editor = monaco.editor.create(node, options);
    editors.set('repl-input', editor);
    setTimeout(function () {
        var container = document.getElementById('input-container');
        container.classList.add('eval-input-window');
        // const backgrounds = [...container.querySelectorAll('.monaco-editor-background'),...container.querySelectorAll('.monaco-editor'),...container.querySelectorAll('.margin')]
        // for (const bg of backgrounds) {
        //     bg.style.backgroundColor = '#1a2e34';
        //     bg.style.cssText += 'background-color: #1a2e34 !important;';
        // }
    }, 0);
    return node;
}
export function layout() {
    var e_1, _a;
    try {
        for (var _b = __values(editors.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var editor = _c.value;
            editor.layout();
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function setValue(v) {
    var e_2, _a;
    try {
        for (var _b = __values(editors.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var editor = _c.value;
            editor.setValue(v);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
console.log(monaco.languages.getLanguages());
